import React, { useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux"
import _ from "lodash"

import { convertToRupiah, getCloudImageUrl, handleProductConditions, estimatedTimeArrivals } from "../../utils";

import Info from "../../images/info1024.png";
import BackArrow from "../../images/shopping-cart-back.png";

import { setUpdateToDefault } from "../../actions/offerAction"
import {useEtaText} from "../../helpers/dom"

const InfoIcon: any = Info
const BackArrowIcon: any = BackArrow

interface history {
  location: {
    state: any
  }
  push: (args: string) => void
}

interface uniqueDefects {
  name: string
}

type OfferLiveProps = {
  history: history
  isKickFairActive: boolean
  setUpdateToDefault: () => any
}

const OfferLive: React.FC<OfferLiveProps> = ({
  history,
  isKickFairActive,
  setUpdateToDefault
}): JSX.Element => {
  const [etaTextObject] = useEtaText()

  // COMPONENT DID MOUNT
  useEffect(() => {
    if (!history.location.state) {
      history.push("/");
    }
    setUpdateToDefault()
  }, [])

  const {
    status,
    product_variant,
    sell,
    size,
    amount,
    currentURL,
    isUpdateOffer,
    updateProductImage
  } = history.location.state || {}

  const {
    user_sell_images = [],
    pre_verified,

  } = sell || {}

  const {
    product,
    product_variant_images = [],
    display_name
  } = product_variant || {}

  const {
    category = {}
  } = product || {}

  /* CONDITION */
  const productImage = (() => {
    const images = status === "USED" || category.name === "handbags"
      ? user_sell_images
      : product_variant_images;

    return images.length > 0 ? images[0] : {}
  })();

  const handleGoToBuyingDashboard = (value) => {
    const params = {
      pathname: '/user_dashboard/order',
      state: { tabs: value }
    }
    history.push(params)
  }

  return (
    <div id="offer-live-page-container">
      <div className="make-offer-detail-container">
        <div className="make-offer-detail-inner-wrapper">
          <div className="detail-description-wrapper">
            <p>{
              isUpdateOffer ?
                "You have successfully update your offer!"
                :
                "You have successfully made an offer!"
            }</p>
            <div
              className="product-image-wrapper"
            >
              <KickImage src={getCloudImageUrl(isUpdateOffer ? updateProductImage : productImage.URL)} />
            </div>
            <p>{display_name}</p>
            <p>US {size.US} / {handleProductConditions(sell, category.name)} / {estimatedTimeArrivals(pre_verified, isKickFairActive, status, etaTextObject)}</p>
            <p>IDR {convertToRupiah(amount)}</p>
          </div>
          <div className="info-description">
            <div
              className="info-icon-wrapper"
            >
              <KickImage src={InfoIcon} alt="info" />
            </div>
            <div
              className="info-container"
            >
              <p>
                The seller has received the news about your offer to the product. Now please wait until the seller either accepts, modifies the prices, or even ignores your offer. You will receive notification if there’s any activities relating to this particular product. If the wait is too long, perhaps you should consider to increase the offer? You can do so simply by repeating the steps or from yout dashboard. Or you can always agree to the seller’s price and buy this now.
              </p>
            </div>
          </div>
          <div className="button-wrapper">
            <div
              onClick={() => history.push(currentURL)}
            >
              {/* <KickImage src={BackArrowIcon} alt="back-button" /> */}
              <p>Back to Market</p>
            </div>
            <div
              onClick={() => handleGoToBuyingDashboard("Offer")}
            >
              <p>View Offer History</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isKickFairActive: state.dataKaFair.isKickFairActive,
});

const mapDispatchToProps = (dispatch) => ({
  setUpdateToDefault: () => dispatch(setUpdateToDefault())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OfferLive))